module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-preview-item",
    attrs: {
      "id": _vm.dataset.id
    }
  }, [_c('div', {
    staticClass: "action-bar row"
  }, [_c('div', {
    staticClass: "col-6 template-info"
  }, [_c('span', {
    staticClass: "_part _title"
  }, [_vm._v(_vm._s(_vm.template.title))]), _vm._v(" "), _c('span', {
    staticClass: "_part _id"
  }, [_vm._v(_vm._s(_vm.template.id))]), _vm._v(" "), _c('span', {
    staticClass: "_part _path"
  }, [_vm._v(_vm._s(_vm.template.path))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 button-group"
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleMoveClick
    }
  }, [_vm._v("\n\t\t\t\tverschieben\n\t\t\t")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.handleDeleteClick
    }
  }, [_vm._v("\n\t\t\t\tlöschen\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    ref: "preview-item",
    staticClass: "preview-item 96a5e0e1b988103acd3676a3bfca66930fb87db"
  }, [_c('div', {
    staticClass: "spinner-wrap"
  }, [_c('erco-cloak', {
    ref: "preview-item-cloak",
    attrs: {
      "vCenter": false
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "deleteConfirmation",
    staticClass: "delete-confirmation-modal",
    attrs: {
      "id": "delete-confirmation",
      "title": "Seite löschen",
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleDeleteConfirmationModalClick
    }
  }, [_c('p', {
    staticClass: "_template"
  }, [_c('span', {
    staticClass: "_path"
  }, [_vm._v(_vm._s(this.dataset.templatePath))]), _vm._v(" "), _c('span', {
    staticClass: "_id"
  }, [_vm._v(_vm._s(this.dataset.templateId))])]), _vm._v(" "), _c('p', {
    staticClass: "_infotext"
  }, [(_vm.textFieldCount || _vm.imgFieldCount) ? _c('span', {
    staticClass: "_fields"
  }, [_vm._v("\n\t\t\t   " + _vm._s(("Wollen Sie diese Seite mit " + (_vm.textFieldCount ? (_vm.textFieldCount + " Text" + (_vm.textFieldCount > 1 ? 'en':'')) : '') + " " + ((_vm.textFieldCount && _vm.imgFieldCount) ? 'und': '') + " " + (_vm.imgFieldCount ? (_vm.imgFieldCount + " Bild" + (_vm.imgFieldCount > 1 ? 'ern':'')) : '') + " wirklich löschen?")) + "\n\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\tWollen Sie diese Seite wirklich löschen?\n\t\t\t")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90e6cb02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoLayout/PreviewItem.vue
// module id = 647
// module chunks = 0